module.exports = __webpack_public_path__ + "img/userDefault.0f8e789e.jpg";